/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerQuickInsightsThresholdSetting } from '../../models/customer-quick-insights-threshold-setting';
import { CustomerQuickInsightsThresholdSettingDto } from '../../models/customer-quick-insights-threshold-setting-dto';

export interface AddSetting$Params {
      body: CustomerQuickInsightsThresholdSettingDto
}

export function addSetting(http: HttpClient, rootUrl: string, params: AddSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
  const rb = new RequestBuilder(rootUrl, addSetting.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerQuickInsightsThresholdSetting>;
    })
  );
}

addSetting.PATH = '/api/customer/quickInsight/threshold/setting';
